import { useState, useEffect } from "react";
const BASE = "https://imalishawelfare.com/api";
const tok = () => sessionStorage.getItem("token");

const Badge = ({ s }) => {
  const map = { PENDING:["#f59e0b","#fff8e6"], APPROVED:["#0066cc","#eff6ff"], DISBURSED:["#10b981","#f0fdf4"], REJECTED:["#ef4444","#fee2e2"], FRAUD_DETECTED:["#7c3aed","#f5f3ff"] };
  const [c, bg] = map[s] || ["#94a3b8","#f8fafc"];
  return <span style={{ background:bg, color:c, borderRadius:4, padding:"2px 8px", fontSize:11, fontWeight:600, whiteSpace:"nowrap" }}>{s}</span>;
};

export default function Dashboard({ setPage }) {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [page, setPageNum] = useState(1);
  const [selected, setSelected] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const perPage = 10;

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/applications`, { headers:{ Authorization:"Bearer "+tok() } });
      if (r.ok) { const d = await r.json(); setApps(d.sort((a,b)=>(b.id||0)-(a.id||0))); }
    } catch(e) {}
    setLoading(false);
  };

  const approve = async (id) => {
    if (!window.confirm("Approve and send login credentials?")) return;
    setActionLoading(true);
    try {
      await fetch(`${BASE}/applications/${id}/approve`, { method:"PUT", headers:{ Authorization:"Bearer "+tok(), "Content-Type":"application/json" }, body:'{"adminNotes":"Approved"}' });
      await load(); setSelected(null);
    } catch(e) { alert("Error: "+e.message); }
    setActionLoading(false);
  };

  const disburse = async (id) => {
    if (!window.confirm("Confirm loan disbursement for this applicant?")) return;
    setActionLoading(true);
    try {
      await fetch(`${BASE}/applications/${id}/disburse`, { method:"PUT", headers:{ Authorization:"Bearer "+tok(), "Content-Type":"application/json" } });
      await load();
    } catch(e) { alert("Error: "+e.message); }
    setActionLoading(false);
  };

  const reject = async (id) => {
    const reason = window.prompt("Enter rejection reason:");
    if (!reason) return;
    setActionLoading(true);
    try {
      await fetch(`${BASE}/applications/${id}/reject`, { method:"PUT", headers:{ Authorization:"Bearer "+tok(), "Content-Type":"application/json" }, body:JSON.stringify({ rejectionReason:reason }) });
      await load(); setSelected(null);
    } catch(e) { alert("Error: "+e.message); }
    setActionLoading(false);
  };

  const parseJust = (j) => {
    const m = {};
    (j||"").split("|").forEach(p => { const i=p.indexOf(":"); if(i>0) m[p.slice(0,i).trim()]=p.slice(i+1).trim(); });
    return m;
  };

  // Stats
  const total = apps.length;
  const pending = apps.filter(a=>a.status==="PENDING").length;
  const approved = apps.filter(a=>a.status==="APPROVED").length;
  const disbursed = apps.filter(a=>a.status==="DISBURSED").length;
  const rejected = apps.filter(a=>a.status==="REJECTED").length;
  const totalFees = apps.reduce((s,a)=>s+(a.loanFeeAmount||0),0);
  const totalLoans = apps.reduce((s,a)=>s+(a.selectedLoanAmount||0),0);

  // Filter
  const filtered = apps.filter(a => {
    const q = search.toLowerCase();
    const matchSearch = !q || a.fullName?.toLowerCase().includes(q) || a.email?.toLowerCase().includes(q) || a.phone?.includes(q) || a.county?.toLowerCase().includes(q);
    const matchStatus = statusFilter==="ALL" || a.status===statusFilter;
    return matchSearch && matchStatus;
  });

  const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
  const pageData = filtered.slice((page-1)*perPage, page*perPage);

  const th = (t) => (
    <th style={{ padding:"10px 12px", textAlign:"left", fontWeight:600, color:"#64748b", fontSize:11, textTransform:"uppercase", letterSpacing:.5, whiteSpace:"nowrap", background:"#f8fafc", borderBottom:"1px solid #e2e8f0" }}>{t}</th>
  );

  return (
    <div style={{ fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif" }}>

      {/* Stats row */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:12, marginBottom:20 }}>
        {[
          ["Total","Applications",total,"#0066cc"],
          ["Pending","Awaiting Review",pending,"#f59e0b"],
          ["Approved","Credentials Sent",approved,"#0052a3"],
          ["Disbursed","Loans Paid Out",disbursed,"#10b981"],
          ["Rejected","Not Qualified",rejected,"#ef4444"],
          ["Total Fees",`KSh ${totalFees.toLocaleString()}`,disbursed+" paid","#7c3aed"],
          ["Total Loans",`KSh ${totalLoans.toLocaleString()}`,disbursed+" disbursed","#10b981"],
        ].map(([label,sub,val,color])=>(
          <div key={label} style={{ background:"white", borderRadius:8, padding:"14px 16px", boxShadow:"0 1px 4px rgba(0,0,0,0.06)", borderTop:`3px solid ${color}` }}>
            <p style={{ fontSize:11, color:"#94a3b8", fontWeight:600, margin:"0 0 4px", textTransform:"uppercase", letterSpacing:.5 }}>{label}</p>
            <p style={{ fontSize:20, fontWeight:800, color, margin:"0 0 2px" }}>{val}</p>
            <p style={{ fontSize:11, color:"#94a3b8", margin:0 }}>{sub}</p>
          </div>
        ))}
      </div>

      {/* Pending alert */}
      {pending > 0 && (
        <div style={{ background:"#fff8e6", border:"1px solid #fbbf24", borderRadius:8, padding:"10px 16px", marginBottom:16, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span style={{ color:"#92400e", fontSize:13, fontWeight:600 }}>
            {pending} application{pending>1?"s":""} pending review
          </span>
          <button onClick={()=>setStatusFilter("PENDING")} style={{ padding:"5px 14px", background:"#f59e0b", color:"white", border:"none", borderRadius:6, fontSize:12, fontWeight:700, cursor:"pointer" }}>Filter Pending</button>
        </div>
      )}

      {/* Main table card */}
      <div style={{ background:"white", borderRadius:10, boxShadow:"0 1px 6px rgba(0,0,0,0.06)", overflow:"hidden" }}>

        {/* Toolbar */}
        <div style={{ padding:"14px 16px", borderBottom:"1px solid #e2e8f0", display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
          <div style={{ position:"relative", flex:1, minWidth:200 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)" }}>
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input value={search} onChange={e=>{setSearch(e.target.value);setPageNum(1);}} placeholder="Search by name, email, phone, county..." style={{ width:"100%", padding:"8px 10px 8px 32px", border:"1px solid #e2e8f0", borderRadius:7, fontSize:13, boxSizing:"border-box", outline:"none" }}/>
          </div>
          <div style={{ display:"flex", gap:4 }}>
            {["ALL","PENDING","APPROVED","DISBURSED","REJECTED"].map(s=>(
              <button key={s} onClick={()=>{setStatusFilter(s);setPageNum(1);}} style={{ padding:"7px 12px", border:"none", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:600, background:statusFilter===s?"#0066cc":"#f1f5f9", color:statusFilter===s?"white":"#64748b" }}>{s}</button>
            ))}
          </div>
          <span style={{ color:"#94a3b8", fontSize:12, marginLeft:"auto" }}>{filtered.length} records</span>
          <button onClick={load} style={{ padding:"7px 14px", background:"#f1f5f9", color:"#64748b", border:"none", borderRadius:7, fontSize:12, fontWeight:600, cursor:"pointer", display:"flex", alignItems:"center", gap:6 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>
            Refresh
          </button>
        </div>

        {/* Table */}
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead>
              <tr>
                {th("Seq")}
                {th("Ref / Name")}
                {th("Phone")}
                {th("Email")}
                {th("County")}
                {th("Category")}
                {th("Business")}
                {th("Purpose")}
                {th("Payment")}
                {th("Loan Amount")}
                {th("Fee")}
                {th("Status")}
                {th("Loan Status")}
                {th("Date")}
                {th("Password")}{th("M-Pesa Receipt")}{th("Docs")}
                {th("Actions")}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={16} style={{ padding:48, textAlign:"center", color:"#94a3b8" }}>Loading data...</td></tr>
              ) : pageData.length===0 ? (
                <tr><td colSpan={16} style={{ padding:48, textAlign:"center", color:"#94a3b8" }}>No records found</td></tr>
              ) : pageData.map((a, idx) => {
                const j = parseJust(a.justification);
                const isSelected = selected?.id===a.id;
                return (
                  <tr key={a.id} onClick={()=>setSelected(isSelected?null:a)}
                    style={{ borderTop:"1px solid #f1f5f9", background:isSelected?"#eff6ff":idx%2===0?"white":"#fafafa", cursor:"pointer" }}
                    onMouseEnter={e=>{ if(!isSelected) e.currentTarget.style.background="#f0f7ff"; }}
                    onMouseLeave={e=>{ if(!isSelected) e.currentTarget.style.background=idx%2===0?"white":"#fafafa"; }}>
                    <td style={{ padding:"10px 12px", color:"#94a3b8", fontSize:12 }}>{(page-1)*perPage+idx+1}</td>
                    <td style={{ padding:"10px 12px", minWidth:160 }}>
                      <div style={{ fontWeight:600, color:"#0066cc", fontSize:12 }}>APP-{a.id}</div>
                      <div style={{ fontWeight:600, color:"#1e293b", fontSize:13 }}>{a.fullName}</div>
                    </td>
                    <td style={{ padding:"10px 12px", color:"#334155", whiteSpace:"nowrap" }}>{a.phone||"—"}</td>
                    <td style={{ padding:"10px 12px", color:"#64748b", fontSize:12, maxWidth:160, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.email||"—"}</td>
                    <td style={{ padding:"10px 12px", color:"#334155", whiteSpace:"nowrap" }}>{a.county||"—"}</td>
                    <td style={{ padding:"10px 12px", whiteSpace:"nowrap" }}>
                      <span style={{ background:"#eff6ff", color:"#0066cc", borderRadius:4, padding:"2px 7px", fontSize:11, fontWeight:600 }}>
                        {(a.category||"—").replace(/_/g," ")}
                      </span>
                    </td>
                    <td style={{ padding:"10px 12px", color:"#64748b", fontSize:12, maxWidth:140, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {j["Business"] ? j["Business"].split(" ").slice(0,3).join(" ") : "—"}
                    </td>
                    <td style={{ padding:"10px 12px", color:"#64748b", fontSize:12, whiteSpace:"nowrap" }}>{j["Purpose"]||"—"}</td>
                    <td style={{ padding:"10px 12px", color:"#64748b", fontSize:12, whiteSpace:"nowrap" }}>
                      {j["Pay"]||"—"}
                      {j["Mpesa"] && <div style={{ color:"#94a3b8", fontSize:11 }}>{j["Mpesa"]}</div>}
                    </td>
                    <td style={{ padding:"10px 12px", fontWeight:700, color:"#10b981", whiteSpace:"nowrap" }}>
                      {a.selectedLoanAmount ? `KSh ${Number(a.selectedLoanAmount).toLocaleString()}` : <span style={{ color:"#94a3b8" }}>Not selected</span>}
                    </td>
                    <td style={{ padding:"10px 12px", color:"#7c3aed", fontWeight:600, whiteSpace:"nowrap" }}>
                      {a.loanFeeAmount ? `KSh ${Number(a.loanFeeAmount).toLocaleString()}` : "—"}
                    </td>
                    <td style={{ padding:"10px 12px" }}><Badge s={a.status}/></td>
                    <td style={{ padding:"10px 12px" }}>
                      {a.loanStatus ? <Badge s={a.loanStatus}/> : <span style={{ color:"#94a3b8", fontSize:12 }}>—</span>}
                    </td>
                    <td style={{ padding:"10px 12px", color:"#94a3b8", fontSize:12, whiteSpace:"nowrap" }}>{a.createdAt?.split("T")[0]||"—"}</td>
                    <td style={{ padding:"10px 12px", fontFamily:"monospace", fontSize:12, color:"#0052a3", fontWeight:600, whiteSpace:"nowrap" }}>
                      {a.generatedPassword||"�"}
                    </td>
                    <td style={{ padding:"10px 12px", color:"#10b981", fontSize:12, fontWeight:600, whiteSpace:"nowrap" }}>
                      {a.mpesaReceiptNumber||"�"}
                    </td>
                    <td style={{ padding:"10px 12px" }}>
                      <div style={{ display:"flex", gap:4 }}>
                        {a.idDocumentUrl && <a href={`https://imalishawelfare.com${a.idDocumentUrl}`} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{ background:"#eff6ff", color:"#0066cc", borderRadius:4, padding:"3px 7px", fontSize:10, fontWeight:600, textDecoration:"none" }} title="View ID">ID</a>}
                        {a.passportPhotoUrl && <a href={`https://imalishawelfare.com${a.passportPhotoUrl}`} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{ background:"#f0fdf4", color:"#16a34a", borderRadius:4, padding:"3px 7px", fontSize:10, fontWeight:600, textDecoration:"none" }} title="View Passport">PP</a>}
                        {a.businessPermitUrl && <a href={`https://imalishawelfare.com${a.businessPermitUrl}`} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{ background:"#fefce8", color:"#ca8a04", borderRadius:4, padding:"3px 7px", fontSize:10, fontWeight:600, textDecoration:"none" }} title="View Permit">BP</a>}
                        {!a.idDocumentUrl && !a.passportPhotoUrl && !a.businessPermitUrl && <span style={{ color:"#94a3b8", fontSize:11 }}>—</span>}
                      </div>
                    </td>
                    <td style={{ padding:"10px 12px" }} onClick={e=>e.stopPropagation()}>
                      <div style={{ display:"flex", gap:4 }}>
                        {a.status==="PENDING" && <>
                          <button onClick={()=>approve(a.id)} disabled={actionLoading} style={{ padding:"4px 10px", background:"#10b981", color:"white", border:"none", borderRadius:5, fontSize:11, fontWeight:600, cursor:"pointer", whiteSpace:"nowrap" }}>Approve</button>
                          <button onClick={()=>reject(a.id)} disabled={actionLoading} style={{ padding:"4px 10px", background:"#fee2e2", color:"#dc2626", border:"none", borderRadius:5, fontSize:11, fontWeight:600, cursor:"pointer" }}>Reject</button>
                        </>}
                        {a.status!=="PENDING" && (
                          <button onClick={()=>setSelected(isSelected?null:a)} style={{ padding:"4px 10px", background:"#eff6ff", color:"#0066cc", border:"none", borderRadius:5, fontSize:11, fontWeight:600, cursor:"pointer" }}>Details</button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{ padding:"12px 16px", borderTop:"1px solid #e2e8f0", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:10 }}>
          <span style={{ color:"#64748b", fontSize:12 }}>
            Items {filtered.length===0?0:(page-1)*perPage+1}–{Math.min(page*perPage,filtered.length)} / Total {filtered.length}
          </span>
          <div style={{ display:"flex", alignItems:"center", gap:4 }}>
            <button onClick={()=>setPageNum(1)} disabled={page===1} style={{ padding:"5px 10px", border:"1px solid #e2e8f0", borderRadius:5, background:"white", cursor:page===1?"not-allowed":"pointer", color:page===1?"#94a3b8":"#334155", fontSize:12 }}>«</button>
            <button onClick={()=>setPageNum(p=>Math.max(1,p-1))} disabled={page===1} style={{ padding:"5px 10px", border:"1px solid #e2e8f0", borderRadius:5, background:"white", cursor:page===1?"not-allowed":"pointer", color:page===1?"#94a3b8":"#334155", fontSize:12 }}>‹</button>
            {Array.from({length:Math.min(5,totalPages)},(_,i)=>{
              let p = page <= 3 ? i+1 : page+i-2;
              if (p > totalPages) return null;
              return <button key={p} onClick={()=>setPageNum(p)} style={{ padding:"5px 10px", border:"1px solid "+(p===page?"#0066cc":"#e2e8f0"), borderRadius:5, background:p===page?"#0066cc":"white", color:p===page?"white":"#334155", cursor:"pointer", fontSize:12, fontWeight:p===page?700:400 }}>{p}</button>;
            })}
            <button onClick={()=>setPageNum(p=>Math.min(totalPages,p+1))} disabled={page===totalPages} style={{ padding:"5px 10px", border:"1px solid #e2e8f0", borderRadius:5, background:"white", cursor:page===totalPages?"not-allowed":"pointer", color:page===totalPages?"#94a3b8":"#334155", fontSize:12 }}>›</button>
            <button onClick={()=>setPageNum(totalPages)} disabled={page===totalPages} style={{ padding:"5px 10px", border:"1px solid #e2e8f0", borderRadius:5, background:"white", cursor:page===totalPages?"not-allowed":"pointer", color:page===totalPages?"#94a3b8":"#334155", fontSize:12 }}>»</button>
            <span style={{ color:"#64748b", fontSize:12, marginLeft:8 }}>{perPage} items/page</span>
          </div>
        </div>
      </div>

      {/* Detail modal */}
      {selected && (() => {
        const j = parseJust(selected.justification);
        return (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={()=>setSelected(null)}>
            <div style={{ background:"white", borderRadius:12, width:"100%", maxWidth:560, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }} onClick={e=>e.stopPropagation()}>
              <div style={{ background:"linear-gradient(135deg,#0052a3,#003d7a)", padding:"20px 24px", display:"flex", justifyContent:"space-between", alignItems:"center", borderRadius:"12px 12px 0 0" }}>
                <div>
                  <p style={{ color:"rgba(255,255,255,0.7)", fontSize:11, margin:"0 0 4px", textTransform:"uppercase", letterSpacing:1 }}>APP-{selected.id}</p>
                  <h3 style={{ color:"white", fontSize:17, fontWeight:700, margin:0 }}>{selected.fullName}</h3>
                </div>
                <button onClick={()=>setSelected(null)} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:"white", borderRadius:8, width:32, height:32, cursor:"pointer", fontSize:18, display:"flex", alignItems:"center", justifyContent:"center" }}>x</button>
              </div>
              <div style={{ padding:"20px 24px" }}>
                {[
                  ["Personal Information",[["Status",<Badge s={selected.status}/>],["Email",selected.email],["Phone",selected.phone||"—"],["County",selected.county||"—"],["Category",(selected.category||"—").replace(/_/g," ")],["Applied",selected.createdAt?.split("T")[0]||"—"]]],
                  Object.keys(j).length>0 ? ["Application Details", Object.entries(j).filter(([k])=>k).map(([k,v])=>[k,v])] : null,
                  selected.selectedLoanAmount ? ["Loan Details",[["Selected Amount",`KSh ${Number(selected.selectedLoanAmount).toLocaleString()}`],["Processing Fee",`KSh ${Number(selected.loanFeeAmount||0).toLocaleString()}`],["Loan Status",selected.loanStatus||"—"]]] : null,
                ].filter(Boolean).map(([title,rows])=>(
                  <div key={title} style={{ marginBottom:20 }}>
                    <p style={{ fontSize:11, fontWeight:700, color:"#0066cc", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:.5 }}>{title}</p>
                    {rows.map(([k,v])=>(
                      <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid #f1f5f9", fontSize:13 }}>
                        <span style={{ color:"#64748b" }}>{k}</span>
                        <span style={{ fontWeight:600, color:"#1e293b", textAlign:"right", maxWidth:280, wordBreak:"break-all" }}>{v}</span>
                      </div>
                    ))}
                  </div>
                ))}
                {(selected.idDocumentUrl||selected.passportPhotoUrl||selected.businessPermitUrl) && (
                  <div style={{ marginBottom:20 }}>
                    <p style={{ fontSize:11, fontWeight:700, color:"#0066cc", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:.5 }}>Uploaded Documents</p>
                    <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                      {selected.idDocumentUrl && <a href={`https://imalishawelfare.com${selected.idDocumentUrl}`} target="_blank" rel="noreferrer" style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 14px", background:"#eff6ff", borderRadius:8, textDecoration:"none", color:"#0066cc", fontSize:13, fontWeight:600 }}>National ID Document <span>View →</span></a>}
                      {selected.passportPhotoUrl && <a href={`https://imalishawelfare.com${selected.passportPhotoUrl}`} target="_blank" rel="noreferrer" style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 14px", background:"#f0fdf4", borderRadius:8, textDecoration:"none", color:"#16a34a", fontSize:13, fontWeight:600 }}>Passport Photo <span>View →</span></a>}
                      {selected.businessPermitUrl && <a href={`https://imalishawelfare.com${selected.businessPermitUrl}`} target="_blank" rel="noreferrer" style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 14px", background:"#fefce8", borderRadius:8, textDecoration:"none", color:"#ca8a04", fontSize:13, fontWeight:600 }}>Business Permit <span>View →</span></a>}
                    </div>
                  </div>
                )}
                <div style={{ display:"flex", gap:10 }}>
                  {selected.status==="PENDING" && <>
                    <button onClick={()=>approve(selected.id)} disabled={actionLoading} style={{ flex:1, padding:"12px", background:"#10b981", color:"white", border:"none", borderRadius:8, fontWeight:700, fontSize:14, cursor:"pointer" }}>Approve and Send Login</button>
                    <button onClick={()=>reject(selected.id)} disabled={actionLoading} style={{ flex:1, padding:"12px", background:"white", color:"#dc2626", border:"1.5px solid #fca5a5", borderRadius:8, fontWeight:600, fontSize:14, cursor:"pointer" }}>Reject</button>
                  </>}
                  {selected.status==="APPROVED" && <div style={{ flex:1, padding:"12px", background:"#eff6ff", borderRadius:8, fontSize:13, color:"#0066cc", fontWeight:600, textAlign:"center" }}>Approved — credentials sent to {selected.email}</div>}
                  {selected.status==="DISBURSED" && <div style={{ flex:1, padding:"12px", background:"#f0fdf4", borderRadius:8, fontSize:13, color:"#16a34a", fontWeight:600, textAlign:"center" }}>Loan disbursed — KSh {Number(selected.selectedLoanAmount||0).toLocaleString()}</div>}
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}










